import {
    SITEPLAN_QUERY,
    SITEPLAN_UPDATE,
    SITEPLAN_UPDATE_UNIT_OUTLINE,
    SITEPLAN_UPDATE_ACTIVE_LOT_INDEX,
    SITEPLAN_UPDATE_LOT_OUTLINES,
    SITEPLAN_UPDATE_ACTIVE_FLOORPLAN_INDEX,
    SITEPLAN_SOURCE_FLOORPLANS,
    SITEPLAN_ADD_ACTIVE_FLOORPLAN_FILTER_INDEX,
    SITEPLAN_REMOVE_ACTIVE_FLOORPLAN_FILTER_INDEX,
    SITEPLAN_CLEAR_ACTIVE_FLOORPLAN_FILTERS,
    SITEPLAN_ACTIVATE_ALL_LOTS_OF_TYPE,
    SITEPLAN_DEACTIVATE_ALL_LOTS_OF_TYPE
} from '../actions/actionTypes';
import { updateActiveFloorplan } from '../actions/floorplanActions';
import lotFaceLogicService from '../../services/lotFaceLogicService';

function floorplanIndexViaFloorplanID(ID, floorplans) {
    if (typeof floorplans !== 'undefined') {
        for (var i = 0; i < floorplans.length; i++) {
            //please dont screw me later
            if (floorplans[i].ID == ID) return i;
        }
    }

    return -1;
}

const initalState = {
    lots: [],
    lotAssociations: [],
    blocks: [],
    floorplans: [],
    activeIndex: -1,
    activeLotIndex: -1,
    activeFlooplanID: -1,
    activeFloorplanFilterIndexes: [],
    highlightedLotsIndexes: [],
    allTypesActive: [],
    displayedFilteredFloorplans: [],
};

function siteplan(state = initalState, action) {
    switch (action.type) {
        case SITEPLAN_QUERY:
            return state;
        case SITEPLAN_UPDATE:
            //add the opacity field to the array quickly
            var lots = action.siteplan;

            for(var i = 0; i < lots.length; i++) {
                lots[i].active = true;
            }

            return Object.assign({}, state, action.siteplan);
        case SITEPLAN_SOURCE_FLOORPLANS:
            //we need to source the floorplans we have with the new floorplans that have been passed in via the action
            var floorplans = [].concat(action.floorplans);

            return Object.assign({}, state, {
                floorplans: floorplans
            });
        case SITEPLAN_UPDATE_ACTIVE_LOT_INDEX:
            return Object.assign({}, state, {
                activeLotIndex: action.activeLotIndex,
                activeFlooplanID: -1
            });
        /*
        case SITEPLAN_UPDATE_ACTIVE_FLOORPLAN_INDEX:
            

            return Object.assign({}, state, {
                activeFlooplanID: action.ID,
                activeLotIndex: -1
            });
        */
        case SITEPLAN_ADD_ACTIVE_FLOORPLAN_FILTER_INDEX:
            //via ID
            var filters = [].concat(state.activeFloorplanFilterIndexes);
            filters.push(action.ID);

            return Object.assign({}, state, {
                activeFloorplanFilterIndexes: filters
            });
        case SITEPLAN_REMOVE_ACTIVE_FLOORPLAN_FILTER_INDEX:
            var filters = [].concat(state.activeFloorplanFilterIndexes);
            var index = -1;

            for(var i = 0; i < filters.length; i++) {
                if(filters[i] == action.ID) {
                    index = i;
                }
            }

            filters.splice(index, 1);
            return Object.assign({}, state, {
                activeFloorplanFilterIndexes: filters
            });
        case SITEPLAN_ACTIVATE_ALL_LOTS_OF_TYPE:
            var filters = [].concat(state.activeFloorplanFilterIndexes);

            //add the lots if the array does not already contain that value
            for(var i = 0; i < action.lots.length; i++) {
                if(!filters.includes(action.lots[i].ID))
                filters.push(action.lots[i].ID);
            }

            return Object.assign({}, state, {
                activeFloorplanFilterIndexes: filters
            });
        case SITEPLAN_DEACTIVATE_ALL_LOTS_OF_TYPE:
            var filters = [].concat(state.activeFloorplanFilterIndexes);
            
            for(var i = 0; i < action.lots.length; i++) {
                if(filters.includes(action.lots[i].ID)) {
                    var index = filters.indexOf(action.lots[i].ID);
                    filters.splice(index, 1);
                }
            }

            return Object.assign({}, state, {
                activeFloorplanFilterIndexes: filters
            });
        case SITEPLAN_CLEAR_ACTIVE_FLOORPLAN_FILTERS:
            var filters = [];

            return Object.assign({}, state, {
                activeFloorplanFilterIndexes: filters
            });
        case SITEPLAN_UPDATE_LOT_OUTLINES:

            //we need a way to get every valid floorplan if its a lot and not a floorplan
            var activeLot = state.activeLotIndex;
            var lots = [].concat(state.lots);
            var lotAssociations = state.lotAssociations;
            var displayedFlooplans = [];
            var floorplans = state.floorplans;
            var lotIndexes = [];
            var filters = state.activeFloorplanFilterIndexes;

           //this should only return something if we have a lot selected

            //now it should be done and we can console log what we got

            //now we just need something to modify the lot stroke colour
            //we don't have an active lot so we should be highlighting more then one
            //lot based on the floorplans that are selected

            if(activeLot == -1) {
                for(var i = 0; i < lots.length; i++) {
                    //this needs to do a few checks for each different lot
                    //1 it needs to check if its the right type to display any of the
                    //floorplans that have been selected

                    //in order to be able to have that floorplna it needs to pass
                    //the lot face logic this is in teh backend but might not work
                    //fully from here ill have to figure out what to do about that
                    
                    //loop the filters and then check each of those floorplans
                    //against this lot to see if its valid
                    var lot = lots[i];
                    var add = true;

                    //going to quickly run a check first to see if the lot has a floorplan
                    //if it does there's no point even bothering with teh rest of the filter
                    if(lot.floorplan) {
                        add = false;                           
                    }

                    if(add) {
                        add = false;

                        for(var j = 0; j < filters.length; j++) {
                            var filter = filters[j];
                                                    
                            //so we will need to see if this lot already has a floorplna
                            //but ill get around to that
                            
                            var vpIndex = floorplanIndexViaFloorplanID(filter, floorplans);
    
                            //check the type
                            if(lot.lot_data.path_data.type == floorplans[vpIndex].type[0].name) {
                                //add = true;
                                //now check if we have the same floorplan
                                for(var k = 0; k < lot.valid_floorplans.length; k++) {
                                    if(floorplans[vpIndex].ID == lot.valid_floorplans[k].floorplan_id) {
                                        add = true;
                                    }
                                }   

                                //this way if we get a single match we highlight
                            }
                            
                            /*
                            if(add) {
                                add = false;
                                //valid fp check
                                for(var k = 0; k < lot.valid_floorplans.length; k++) {
                                    if(floorplans[vpIndex].ID == lot.valid_floorplans[k].floorplan_id) {
                                        add = true;
                                    }
                                }   
                            }
                            */

                            /*
                            if(add) {
                                //corner check
                                if(floorplans[vpIndex].is_corner) {
                                    if(lot.is_corner) add = true;
                                    else add = false;
                                }
                                else {
                                    if(!lot.is_corner) add = true;
                                    else add = false;
                                }
                            }
                            */
                        }
                    }

                    if(add) {
                        lotIndexes.push(i);
                    }
                }
            }
            else {
                //we have an active lot and need to check which of the floorplans
                //that are allowed of the type of lot are allowed to show up
                //on that lot ( i don't know if the filters should apply to this)
                //seems like it would be confusing if it didnt'
                //only highlight the active lot then we need to pick the valid floorplans kind of backwards logic to before

                lotIndexes.push(activeLot);
                var lot = lots[activeLot];

                //now its just about setting up the displayed filteredfloorplans which includes the elvations
                //just do all of the floorplans for now
                for(var i = 0; i < floorplans.length; i++) {
                    var add = false;
                    var addElevations = [];

                    if(lot.lot_data.path_data.type == floorplans[i].type[0].name) {
                        add = true;
                    }

                    //add in a new check against the valid floorplans of this lot to see if this one is allowed on this lot
                    if(add) {
                        //just console.log the valid floorplans i guess here
                        add = false;

                        for(var j = 0; j < lot.valid_floorplans.length; j++) {
                            if(floorplans[i].ID == lot.valid_floorplans[j].floorplan_id) {
                                add = true;
                            }
                        }
                    }

                    if(add) {
                        //maybe its failing on the corner check
                        if(lot.is_corner) {
                            if(floorplans[i].is_corner)
                                add = true;
                            else
                                add = false;
                        }
                        else {
                            if(!floorplans[i].is_corner) add = true;
                            else add = false;
                        }
                    }

                    var fitleredElevations = [];

                    if(add) {
                        //do the lot f a ce check here now from the lotfaceservice
                        //now we just need to gather all of the data and run this

                        //loop the elevations and run the check
                        var streetAssociations = [];
                        for(var j = 0; j < lotAssociations.length; j++) {
                            if(lotAssociations[j].lot_one_id == activeLot) {
                                streetAssociations.push(lots[lotAssociations[j].lot_two_id]);
                            }
                            else if(lotAssociations[j].lot_two_id == activeLot) {
                                streetAssociations.push(lots[lotAssociations[j].lot_one_id]);
                            }
                        }

                        for(var j = 0 ; j < floorplans[i].elevation.length; j++) {
                            //we need like 7 variables
                            //lot
                            //associations for that lot
                            //current floorplan
                            //current elevationIndex
                            //all blocks
                            //all lots
                            //all of the lotassociations
                            //i should have all of this data in teh siteplan reducer
                            //i just need to go look how i packaged everything
                            //something is happening in here on corners
                            if(lotFaceLogicService.floorplanElevationValidityCheck(
                                lot,
                                streetAssociations,
                                floorplans[i],
                                j,
                                state.blocks,
                                lots,
                                lotAssociations
                            )) {
                                //add the floorplan with a key to say which elevation we are
                                fitleredElevations.push(j);
                            }
                        }
                    }

                    if(add) {
                        displayedFlooplans.push({
                            floorplan:floorplans[i],
                            elevations: fitleredElevations
                        });
                    }

                    //this check is gonna need to go over all the elvations
                }
            }


            return Object.assign({}, state, {
                lots: lots,
                displayedFilteredFloorplans: displayedFlooplans,
                highlightedLotsIndexes: lotIndexes
            });
        default:
            return state;
    }
}

export default siteplan; 